// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "-" + {"3150":"3c64335d","4849":"efc4d37a"}[chunkId] + ".chunk.css";
};